// File: src/components/tables/GenericTable/BulkActionsBar.tsx
import React from "react";
import styled from "styled-components";
import { Typography } from "../../general/Typography";
import { Flex } from "../../layouts";

export interface BulkActionsBarProps {
  selectedCount: number;
  children?: React.ReactNode;
}

const BarWrapper = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  background: ${({ theme }) => theme.colors.surfaceHover};
  border-radius: ${({ theme }) => theme.radii.md};
  box-shadow: ${({ theme }) => theme.elevations.low};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
  }
`;



export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  selectedCount,
  children,
}) => {
  if (selectedCount === 0) return null;

  return (
    <BarWrapper>
      <Typography variant="caption" as="span">
        {selectedCount} selected
      </Typography>
      <Flex gap="sm" align="center" >
        {children}
      </Flex>
    </BarWrapper>
  );
};